module.exports = __webpack_public_path__ + "img/21_102.104c1e0c.png";